import { 
  Dialog, 
  DialogContent, 
  DialogContentText, 
  DialogTitle, 
  IconButton, 
  Divider 
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MRInfo from '../utils/MRInfo';
import PropTypes from 'prop-types';

const InformationPopup = ({open, onClose, content}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby='information-title'
      aria-describedby='information-description'
      PaperProps={{ sx: { minWidth: '40em' } }}
    >

      <Divider sx={{ borderColor: '#FDC203', borderWidth: '4.5px' }}/>

      <DialogTitle
        sx={{ fontSize: '16px', fontWeight: '800', textTransform: 'uppercase', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
        id='information-title'
      >
        { MRInfo[content].title }
        <IconButton
          aria-label='close modal'
          onClick={onClose}
        >
          <CloseIcon style={{ padding: 0 }} />
        </IconButton>
      </DialogTitle>

      <Divider sx={{ marginX: '20px' }}/>

      {
        content !== 'courtesyRides' 
        ? <DialogContent>
            <DialogContentText id='information-description' sx={{ fontSize: '16px', fontWeight: '400'}}>
              { MRInfo[content].description }
            </DialogContentText>
          </DialogContent>
        : <DialogContent>
            <DialogContentText id='information-description' sx={{ fontSize: '16px', fontWeight: '400'}}>
              { MRInfo[content].description }
            </DialogContentText>
            {
              MRInfo[content].subtitles.map((subtitle, index) => (
                <div key={index}>
                  <DialogTitle sx={{ fontSize: '16px', fontWeight: '800', paddingLeft: 0 }}>
                    { subtitle }
                  </DialogTitle>
                  <DialogContentText sx={{ fontSize: '14px', fontWeight: '400'}}>
                    { MRInfo[content].featureList[index].map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </DialogContentText>
                  <DialogContentText sx={{ fontSize: '14px', fontWeight: '400', marginTop: '10px'}}>
                    { MRInfo[content].footers[index] }
                  </DialogContentText>
                </div>
              )) 
            }
          </DialogContent>
      }

    </Dialog>
  )
}

InformationPopup.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  content: PropTypes.string
}

export default InformationPopup;